var exports = {
  "p": "xfb577c5e--aac264--list",
  "x": "xfb577c5e--aac264--list-item",
};

module.exports = exports;
